F<template>
      <img class="rounded-circle" v-if="imageBytes && !uploading" v-bind:src="'data:image/jpeg;base64,' + imageBytes"
   style="object-fit: cover; max-width: 100%; max-height: 100%;" />
    


  
</template>

<script>
import axios from "axios";
export default {
  props: ["cedula"],
  data() {
    return {
      errorMessage: "",
      dialog: false,
      snackbar: false,
      uploading: false,
      uploadCompleted: false,
      fileId: null,
      file: null,
      percentCompleted: 0,
      imageBytes: null,
    };
  },
  mounted() {
    this.cargarFoto();
  },
  methods: {
    cargarFoto() {
      axios.get('/persona/' + this.cedula + '/foto').then(res => {
        this.imageBytes = res.data.fileContent;
      }).catch(err => console.log(err));
    },
  }
};
</script>
